import * as React from 'react';

import CheckBox, { CheckboxProps } from '@mui/material/Checkbox';

type ExtendedCheckboxProps = CheckboxProps & {
  // Kept for existing callers; every checkbox now uses the theme's MuiCheckbox.
  updatedStyling?: boolean;
};

const Checkbox = React.forwardRef<HTMLInputElement, ExtendedCheckboxProps>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ updatedStyling, ...props }, ref) => <CheckBox inputRef={ref} {...props} />
);

Checkbox.displayName = 'CustomCheckbox';

export default Checkbox;
export type { CheckboxProps };
export { Checkbox };
